import apiSlice from "./apiSlice";


const homeApiSlice = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        products: build.query({
            query: () => (`/core/products/`)
        })
    })
})


export const { useProductsQuery } = homeApiSlice;